import { render } from "./ResultScreen.vue?vue&type=template&id=b21fbc2c"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/ruslan/projects/sporttiming/app/front/do/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__